<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="copyright">First published in 2020 by</p>
<p class="copyright">Birlinn Limited</p>
<p class="copyright">West Newington House</p>
<p class="copyright">10 Newington Road</p>
<p class="copyright">Edinburgh</p>
<p class="copyright">EH9 1QS</p>
<p class="copyright1"><em><a href="http://www.birlinn.co.uk" target="_blank">www.birlinn.co.uk</a></em></p>
<p class="copyright1">Copyright © Angus MacDonald 2020</p>
<p class="copyright1">The moral right of Angus MacDonald to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copyright1">All rights reserved. No part of this publication may be reproduced, stored or transmitted in any form without the express written permission of the publisher.</p>
<p class="copyright1">ISBN: 978 1 78885 294 4</p>
<p class="copyright1">British Library Cataloguing-in-Publication Data A catalogue record for this book is available from the British Library</p>
<p class="copyright1"><img alt="Illustration" src="images/copy.png"/></p>
<p class="copyright1">Typeset by Hewer Text UK Ltd, Edinburgh</p>
<p class="copyright">Printed and bound by Clays Ltd, Elcograf S.p.A.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?421ee8f7